import type { CharacterDef } from '../characters/types';
import { DUEL_STAT_PROFILES, type DuelLevel } from './aiSkill';
import type { Fighter } from './types';

/** Applies shared level scaling and the character's optional non-Expert correction once. */
export function applyDuelLevelStats(
  fighter: Fighter,
  character: CharacterDef,
  level: DuelLevel,
): void {
  if (level === 'expert') return;
  const shared = DUEL_STAT_PROFILES[level];
  const own = character.combat?.levels?.[level];
  const hpScale = shared.hitPoints * (own?.hitPoints ?? 1);
  fighter.maxHp = Math.max(1, fighter.maxHp * hpScale);
  fighter.hp = Math.max(1, fighter.hp * hpScale);
  fighter.damage *= shared.damage * (own?.damage ?? 1);
  fighter.attackInterval *= shared.attackInterval * (own?.attackInterval ?? 1);
  fighter.effectChance = clamp01(
    fighter.effectChance * shared.effectChance * (own?.effectChance ?? 1),
  );
  fighter.protection = Math.min(
    0.75,
    fighter.protection * shared.protection * (own?.protection ?? 1),
  );
}

function clamp01(value: number): number {
  return Math.max(0, Math.min(1, value));
}
